import script from "./PrivacyPolicyView.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyView.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=31b4e20f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31b4e20f"]])

export default __exports__